@if (label()) {
    <p-floatlabel [variant]="labelVariant()">
        <ng-container [ngTemplateOutlet]="control" />
        <label [attr.for]="inputId()">
            {{ label() }}
            @if (required()) {
                <span>*</span>
            }
            @if (info(); as content) {
                <kno2-info-popover
                    class="ml-1 align-middle"
                    [title]="infoTitle()"
                    [content]="content" />
            }
        </label>
    </p-floatlabel>
} @else {
    <ng-container [ngTemplateOutlet]="control" />
}
<ng-template #control>
    <p-select
        appendTo="body"
        [options]="options()"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [group]="group()"
        [optionGroupLabel]="optionGroupLabel()"
        [optionGroupChildren]="optionGroupChildren()"
        [placeholder]="placeholder() ?? ''"
        [inputId]="inputId()"
        [invalid]="showInvalid()"
        [showClear]="showClear()"
        [size]="size()"
        [disabled]="disabled()"
        [style]="fullWidthStyle"
        [ngModel]="value()"
        (ngModelChange)="handleChange($event)"
        (onBlur)="markTouched()"
        [ngModelOptions]="standaloneNgModel" />
</ng-template>
@if (showError() && errorMessage(); as message) {
    <small class="kno2-form-control">{{ message }}</small>
}
